import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router-dom';
import { Client } from '../types/Client';
import {
  getClient,
  editClient,
  editClientToastClose,
  editClientCorrection,
  getMasterClients
} from '../actions/userActions';
import getCountryList from '../assets/countryListUtility';
import {
  withStyles,
  WithStyles,
  Card,
  CardContent,
  CardActions,
  Checkbox,
  Typography,
  Modal,
  CardHeader,
  IconButton,
  Button,
  Grid,
  FormControl,
  FormControlLabel,
  FormGroup,
  Radio,
} from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import CloseIcon from '@material-ui/icons/Close';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CustomInfoIcon from '../../common/CustomInfoIcon';
import { userStyles } from '../styles';
import { MyPATTextField, MyPATSelect } from '../../common';
import { GOAL_ACTION_TYPE_CONST } from '../../goal-management/container/GoalManagementContainer';
import DialogHeader from '../common/DialogHeader';
import clientServices from '../services/userServices';


interface EditClientDialogProps extends WithStyles<typeof userStyles> {
  isDialogOpen: boolean;
  dialogCloseHandler: () => void;
  dialogData: any;
  actionType: string;
  getGoalList: () => void;
  id: string;
  history: any;
  eventsName: any;
  client: any;
  getClient: any;
  editClient: any;
  match: any;
  editFormErrors: any;
  clientEditedSuccessfully: boolean;
  editClientToastClose: any;
  editClientCorrection: any;
  masterClientsData: any;
  getMasterClients: Function;
}


interface MasterClientData {
  _id: string, 
  name: string
}

interface ModuleAccess {
  goalManagement: boolean;
  userManagement: boolean;
  courseManagement: boolean;
  EDPReports: boolean;
  contentRequest: boolean;
}

interface ModuleObject {
  type: string,
  name: string,
  isAllowed: boolean
}

interface localModuleObject {
  goal?: string,
  course?: string,
  user?: string,
  edp?: string,
  content?: string
}

interface EditClientDialogState {
  open: boolean;
  setOpen: boolean;
  formData: any;
  formErrors: any;
  isFormValid: any;
  clientId: any;
  moduleAccessData: any;
  shouldCheckBoxBeDisabled: boolean;
  clientUpdated: boolean;
  clientData: any;
}

class EditClientDialog extends Component<
  EditClientDialogProps,
  EditClientDialogState
> {
  modules = ['goal', 'user', 'course', 'edp', 'content']

  componentDidMount() {
    
    const {
      match: { params },
    } = this.props;
    const clientId = params.clientId;
    this.props.getClient(clientId);
    this.props.getMasterClients();

  }

  constructor(props: EditClientDialogProps) {
    super(props);

    this.state = {
      open: false,
      setOpen: false,
      formData: {
        client: {
          name: '',
          address: '',
          moduleAccess: [
            {
              type: 'module',
              name: 'goal',
              isAllowed: null,
            },
            {
              type: 'module',
              name: 'course',
              isAllowed: null,
            },
            {
              type: 'module',
              name: 'content',
              isAllowed: null,
            },
            {
              type: 'module',
              name: 'user',
              isAllowed: null,
            },
            {
              type: 'module',
              name: 'edp',
              isAllowed: null,
            },
          ],
          isBranchClient: false,
          masterClient: {
            id: '',
            name: ''
          }
        },
        user: {
          fullName: '',
          email: '',
          mobile: {
            countryCode: '+91',
            number: '',
          },
        },
      },
      clientData: {
        client: {
          name: '',
          address: '',
          moduleAccess: [
            {
              type: 'module',
              name: 'goal',
              isAllowed: null,
            },
            {
              type: 'module',
              name: 'course',
              isAllowed: null,
            },
            {
              type: 'module',
              name: 'content',
              isAllowed: null,
            },
            {
              type: 'module',
              name: 'user',
              isAllowed: null,
            },
            {
              type: 'module',
              name: 'edp',
              isAllowed: null,
            },
          ],
          isBranchClient: false,
          masterClient: {
            id: '',
            name: ''
          }
        },
        user: {
          fullName: '',
          email: '',
          mobile: {
            countryCode: '+91',
            number: '',
          },
          empCode: '',
        },
      },
      formErrors: {
        name: 'valid',
        address: 'valid',
        fullName: 'valid',
        email: 'valid',
        number: 'valid',
        empCode: 'valid',
      },
      isFormValid: false,
      clientId: '',
      moduleAccessData: {},
      shouldCheckBoxBeDisabled: false,
      clientUpdated: false
    };

    this.handleChange = this.handleChange.bind(this);
  }

  componentDidUpdate(prevProps: any, prevState: any) {
    
    
    if (prevProps.client !== this.props.client ) {
      this.setFormData(this.props.client);
      if(this.props.client.isBranchClient){
        this.setState({
          shouldCheckBoxBeDisabled: true
        })
      }
    }
  }

  setFormData = (clientDataReceived: any) => {
    
    const moduleAccessDataReceived = clientDataReceived.access
    let localModuleAccessData:localModuleObject = {};
    this.modules.forEach((module: string) => {
      const moduleData = moduleAccessDataReceived.find((moduleReceived: any) => moduleReceived.name === module);
      
      if(moduleData !== undefined){
        switch(module){
          case 'goal': localModuleAccessData.goal = moduleData.isAllowed; break;
          case 'user': localModuleAccessData.user = moduleData.isAllowed; break;
          case 'course': localModuleAccessData.course = moduleData.isAllowed; break;
          case 'edp': localModuleAccessData.edp = moduleData.isAllowed; break;
          case 'content': localModuleAccessData.content = moduleData.isAllowed; break;
          default:
        }
      }
    });
    
    let clientData = {
      client: {
        name: `${
          clientDataReceived.name
            ? clientDataReceived.name
            : this.state.formData.client.name
        }`,
        address: `${
          clientDataReceived.address
            ? clientDataReceived.address
            : this.state.formData.client.address
        }`,
        moduleAccess: [
          {
            type: 'module',
            name: 'goal',
            isAllowed: !!localModuleAccessData.goal
              
          },
          {
            type: 'module',
            name: 'course',
            isAllowed: !!localModuleAccessData.course
              
          },
          {
            type: 'module',
            name: 'content',
            isAllowed: !!localModuleAccessData.content
              
          },
          {
            type: 'module',
            name: 'user',
            isAllowed: !!localModuleAccessData.user
              
          },
          {
            type: 'module',
            name: 'edp',
            isAllowed: !!localModuleAccessData.edp
              
          },
        ],
        isBranchClient: 
          clientDataReceived
          && clientDataReceived.isBranchClient
          
        ,
        masterClient: {
          id: `${
            clientDataReceived.masterClient
            ? clientDataReceived.masterClient.id
            : this.state.formData.client.masterClient.id
          }`,
          name: `${
            clientDataReceived.masterClient
            ? clientDataReceived.masterClient.name
            : this.state.formData.client.masterClient.name
          }`
        }
      },
      user: {
        fullName: `${
          clientDataReceived &&
          clientDataReceived.adminsData &&
          clientDataReceived.adminsData.length > 0 &&
          (clientDataReceived.adminsData[0].firstName ||
            clientDataReceived.adminsData[0].lastName)
            ? clientDataReceived.adminsData[0].firstName +
              ' ' +
              clientDataReceived.adminsData[0].lastName
            : this.state.formData.user.fullName
        }`,
        email: `${
          clientDataReceived &&
          clientDataReceived.adminsData &&
          clientDataReceived.adminsData.length > 0 &&
          clientDataReceived.adminsData[0].email
            ? clientDataReceived.adminsData[0].email
            : this.state.formData.user.email
        }`,
        mobile: {
          countryCode: `${
            clientDataReceived &&
            clientDataReceived.adminsData &&
            clientDataReceived.adminsData.length > 0 &&
            clientDataReceived.adminsData[0].mobile
              ? clientDataReceived.adminsData[0].mobile.countryCode
              : this.state.formData.user.mobile.countryCode
          }`,
          number: `${
            clientDataReceived &&
            clientDataReceived.adminsData &&
            clientDataReceived.adminsData.length > 0 &&
            clientDataReceived.adminsData[0].mobile
              ? clientDataReceived.adminsData[0].mobile.number
              : this.state.formData.user.mobile.number
          }`,
        },
        empCode: `${
          clientDataReceived &&
          clientDataReceived.adminsData &&
          clientDataReceived.adminsData.length > 0 &&
          clientDataReceived.adminsData[0].empCode
            ? clientDataReceived.adminsData[0].empCode
            : this.state.formData.user.empCode
        }`,
      },
    };

    this.setState({ formData: clientData, clientData });
  };

  getMasterClientName = (id:string) => {
    return this.props.masterClientsData.filter((client:MasterClientData) => client._id === id)
  }

  handleChange = (event: any) => {
    let { formData, formErrors } = this.state;
    let { name, value } = event.target;
    

    this.props.editClientCorrection();
    let error = this.validateField(name, value);
    if (error !== undefined && error !== '') {
      
      formErrors[name] = error;
    }
    

    switch (name) {
      case 'name':
        formData.client.name = value;
        break;
      case 'address':
        formData.client.address = value;
        break;
      case 'fullName':
        formData.user.fullName = value;
        break;
      case 'empCode':
        formData.user.empCode = value;
        break;
      case 'email':
        formData.user.email = value;
        if(formData.client.isBranchClient && this.checkEmailValidity(value.trim())) {
          clientServices.getUsersByEmail(value).then((res: any) => {
            formData.user.mobile.countryCode = _.get(res, 'users[0].mobile.countryCode', '+91') ? _.get(res, 'users[0].mobile.countryCode', '+91') : formData.user.mobile.countryCode;
            formData.user.mobile.number = _.get(res, 'users[0].mobile.number', '') ?  _.get(res, 'users[0].mobile.number', '') : formData.user.mobile.number;
            let name = `${_.get(res, 'users[0].firstName', '')} ${_.get(res, 'users[0].lastName', '')}`;;
            name = name.replace(/[^\w\s]/gi, "");
            name = name.trim();
            formData.user.fullName = name !== "" ? name : formData.user.fullName;
          })
        }
        break;
      case 'number':
        formData.user.mobile.number = value;
        break;
      case 'checkbox':
        formData.client.isBranchClient = !formData.client.isBranchClient;
        break;
      case 'masterClient':
        formData.client.masterClient.name = this.getMasterClientName(value)[0] && this.getMasterClientName(value)[0].name;
        formData.client.masterClient.id = this.getMasterClientName(value)[0] && this.getMasterClientName(value)[0]._id;
        break;
      default:
    }
    setTimeout(() => {
      this.setState({ formData, formErrors });
    }, 1000)
    this.anyFormErrors();
  };

  validateField = (name: any, value: any) => {
    switch (name) {
      case 'name':
        return this.checkclientNameValidity(value)
          ? 'valid'
          : 'Please enter atleast 3 characters';
      case 'address':
        return this.checkclientAddressValidity(value)
          ? 'valid'
          : 'Please enter atleast 5 characters';
      case 'fullName':
        return this.checkUserNameValidity(value)
          ? 'valid'
          : 'Please enter atleast 3 characters';
      case 'email':
        return this.checkEmailValidity(value.trim())
          ? 'valid'
          : 'Please enter a valid email ID';
      case 'empCode':
        return this.checkEMPCodeValidity(value)
          ? 'valid'
          : 'Please enter a valid EMP Code';
      case 'number':
        return this.checkmobileValidity(value)
          ? 'valid'
          : 'Please enter a valid mobile number';
      default:
        return '';
    }
  };

  checkclientNameValidity = (clientName: string) => {
    let isclientNameValid = true;
    if (clientName === '' || clientName.length < 3) {
      isclientNameValid = false;
      
    }
    return isclientNameValid;
  };

  checkclientAddressValidity = (clientAddress: string) => {
    let isclientAddressValid = true;
    if (clientAddress === '' || clientAddress.length < 5) {
      isclientAddressValid = false;
    }
    return isclientAddressValid;
  };

  checkUserNameValidity = (name: string) => {
    let isNameValid = true;
    if (name === '' || name.length < 3) {
      isNameValid = false;
    }
    return isNameValid;
  };

  checkEmailValidity = (email: string) => {
    let isEmailValid = true;
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    isEmailValid = re.test(String(email).toLowerCase());
    return isEmailValid;
  };

  checkEMPCodeValidity = (code:string) => {
    let isCodeValid = true;
    if (code.length !== 5) {
      isCodeValid = false;
    }
    return isCodeValid;
  }

  checkmobileValidity = (mobile: string) => {
    let ismobileValid = true;
    const allCountries = getCountryList();
    const country = allCountries.find(
      (country) =>
        country.dialCode === this.state.formData.user.mobile.countryCode
    );
    const pattern = country && country.regex ? country.regex : '';
    const regexObj = new RegExp(pattern);
    

    if (!regexObj.test(mobile)) {
      ismobileValid = false;
      return ismobileValid;
    } else if (this.props.editFormErrors.number) {
      this.props.editFormErrors.number = 'This field is required.';
      return true;
    }
  };

  handleModuleAccess = (event: any, i: any) => {
    
    let name = event.target.name;
    let value = event.target.value;
    

    
    
    this.setState((prevState) => {
      const newFormData = { ...prevState.formData };
    const newModuleAccess = [...newFormData.client.moduleAccess];
    newModuleAccess[i] = {
      ...newModuleAccess[i],
      isAllowed: value === 'Yes' ? true : false,
    };
    newFormData.client.moduleAccess = newModuleAccess;
      return {
        ...prevState,
        formData: newFormData,
        isFormValid: true,
      }
    });
  };

  handleSubmit = (event: any) => {
    event.preventDefault();
    const {
      match: { params },
    } = this.props;
    const clientId = params.clientId;
    
    let anyErrors = this.anyFormErrors();
    if (!anyErrors) {
      
      this.props.editClient({
        formData: this.state.formData,
        clientId: clientId,
      });
    }
    
    this.setState({
      isFormValid: false,
      clientUpdated: true
    });
  };

  anyFormErrors = () => {
    let errorsExist = false;

    if (
      this.state.formErrors.name !== 'valid' ||
      this.state.formErrors.address !== 'valid' ||
      this.state.formErrors.fullName !== 'valid' ||
      this.state.formErrors.number !== 'valid' ||
      this.state.formErrors.email !== 'valid' ||
      this.state.formErrors.empCode !== 'valid'
    ) {
      errorsExist = true;
      this.setState({
        isFormValid: false,
      });
      return errorsExist;
    }

    // Enable Submit Button Here
    this.setState({
      isFormValid: true,
    });

    return errorsExist;
  };

  handleReset = () => {
    this.setState({
      open: false,
      setOpen: false,
      formData: {
        client: {
          name: '',
          address: '',
          moduleAccess: [
            {
              type: 'module',
              name: 'goal',
              isAllowed: 'true',
            },
            {
              type: 'module',
              name: 'course',
              isAllowed: 'true',
            },
            {
              type: 'module',
              name: 'content',
              isAllowed: 'true',
            },
            {
              type: 'module',
              name: 'user',
              isAllowed: 'true',
            },
            {
              type: 'module',
              name: 'edp',
              isAllowed: 'true',
            },
          ],
        },
        user: {
          fullName: '',
          email: '',
          mobile: {
            countryCode: '+91',
            number: '',
          },
          empCode: '',
        },
      },
      formErrors: {
        name: '',
        address: '',
        fullName: '',
        email: '',
        number: '',
        empCode: '',
      },
      isFormValid: false,
      shouldCheckBoxBeDisabled: false,
      clientUpdated: false
    });
  };

  getCountryItemsList = () => {
    const countryList = getCountryList();
    const { classes } = this.props;

    const countryListMenuItems = countryList.map((country: any, index: any) => {
      return (
        <MenuItem
          key={index}
          value={`${country.dialCode}`}
          className={classes.menuItem}
        >
          <img src={`${country.flag}`} alt={`${country.name}`} />
          {country.dialCode}
        </MenuItem>
      );
    });

    return countryListMenuItems;
  };

  handleCountryCodeChange = (event: any) => {
    let { formErrors } = this.state;
    const countryCode = event.target.value;
    const formData = this.state.formData;
    formData.user.mobile.countryCode = countryCode;

    let error = this.validateField('number', this.state.formData.user.mobile.number);
    if (error !== undefined && error !== '') {
      
      formErrors.number = error;
    }

    this.setState({ 
      formData, 
      formErrors,
      isFormValid: true });
  };

  handleToaster = () => {
    this.props.editClientToastClose();
  };

  renderSelectOptions = () => {
    let options = [];
    options.push(<option value={''}>{'Select Organization'}</option>)
    _.map(this.props.masterClientsData, (client: any, i: number) => (
      options.push(<option key={i} value={client._id} >{client.name}</option>)
    ))
    return options;
  }

  render() {
    
    
    const countryListItems = this.getCountryItemsList();
    const { classes, dialogCloseHandler } = this.props;    
    return (
      <>
        {this.props.clientEditedSuccessfully && (
          <Grid
            className={[classes.customToaster, classes.successTooltip].join(
              ' '
            )}
          >
            <Typography variant="h6">
              <span>
                <CheckCircleIcon />
              </span>
              <span>Client Updated Successfully</span>
              <span className="closeIcon" onClick={this.handleToaster}>
                <CloseIcon />
              </span>
            </Typography>
          </Grid>
        )}
        <Modal
          BackdropProps={{ invisible: true }}
          disablePortal
          disableEnforceFocus
          disableAutoFocus
          hideBackdrop={true} //@Neeraj: try to follow the Material UI doc for UI Arch
          className={[
            classes.fontSizeLG,
            classes.fontWeight500,
            classes.modal,
          ].join(' ')}
          open={true}
        >
          <div className={classes.paper}>
            <Card elevation={0}>
            <DialogHeader 
              urlName="/userManagement"
              selectedTab="Clients"
              iconNode={
                  <IconButton
                    aria-label="settings"
                    onClick={dialogCloseHandler}
                  >
                    <CloseIcon className={classes.fontSizeLG} />
                  </IconButton>              
              }
              headerTitle="Edit Client"
              />
              <CardContent className={classes.cardContentStyle}>
                <Card className={classes.CustomCard}>
                  <Grid container spacing={8}>
                    <Grid item xs={6}>
                      <Typography
                        variant="body1"
                        gutterBottom
                        className={classes.fontSizeMD}
                      >
                        Client/Org.
                      </Typography>
                      <MyPATTextField
                        className={classes.inputWidth}
                        fullWidthControl
                        inputId="name"
                        name="name"
                        placeholder="Enter the name of the client"
                        // disabled={actionType === GOAL_ACTION_TYPE_CONST.READ_ONLY}
                        value={this.state.formData.client.name || ''}
                        onChange={this.handleChange.bind(this)}
                        error={
                          // !this.state.isEdit.editedClient &&
                          this.state.formErrors.name !== 'valid' ||
                          this.props.editFormErrors.name.includes(
                            'already exists'
                          )
                            ? true
                            : false
                        }
                        errorText={
                          this.state.formErrors.name === 'valid'
                            ? this.props.editFormErrors.name
                            : this.state.formErrors.name
                        }
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <Typography
                        variant="body1"
                        gutterBottom
                        className={classes.fontSizeMD}
                      >
                        Address
                      </Typography>
                      <MyPATTextField
                        className={[classes.inputWidth, classes.customTextarea].join(' ')}
                        fullWidthControl
                        inputId="address"
                        name="address"
                        multiline
                        rows={4}
                        placeholder="Enter Address"
                        // disabled={actionType === GOAL_ACTION_TYPE_CONST.READ_ONLY}
                        value={this.state.formData.client.address || ''}
                        onChange={this.handleChange.bind(this)}
                        error={
                          // !this.state.isEdit.editedAddress &&
                          this.state.formErrors.address !== 'valid'
                            ? true
                            : false
                        }
                        errorText={this.state.formErrors.address}
                      />
                    </Grid>
                  </Grid>
                  <Grid container spacing={8}>
                      <Grid item xs={6}>
                      <FormControlLabel
                          value="primary"
                          control={
                            <Checkbox
                              checked={this.state.formData.client.isBranchClient}
                              onClick={this.handleChange.bind(this)}
                              // classes={{
                              //   root: classes.checkbox,
                              //   checked: classes.checkedCheckbox,
                              //   colorPrimary: classes.primaryColor
                              // }}
                              color="primary"
                              name="checkbox"
                              disabled={this.state.shouldCheckBoxBeDisabled || 
                                (
                                  this.state.clientUpdated &&
                                  this.state.formData.client.isBranchClient !== this.props.client.isBranchClient
                                )}
                           />
                          }
                          label="Client is a centre/branch*"
                          classes={{ label: classes.customLabel }}
                        />
                      
                          {/* <Typography
                            variant="body1"
                            gutterBottom
                            className={classes.fontSizeMD}
                          >
                          Client is a centre/branch
                        </Typography> */}
                      </Grid>
                      <Grid item xs={6}>
                        {  this.state.formData.client.isBranchClient && <><Typography
                          variant="body1"
                          gutterBottom
                          className={classes.fontSizeMD}
                        >
                          Main Organization
                        </Typography>
                          <MyPATSelect
                            // inputId={featurePermission}
                            // value={this.state.formData.client.masterClient.name}
                            name='masterClient'
                            onChange={(e: any) => this.handleChange(e)}
                            disabled={
                              !this.state.formData.client.isBranchClient
                            }
                            inputClass={classes.selectOrgStyle}
                          >
                            {
                              this.props.client.isBranchClient 
                              ? <option value={this.state.formData.client.masterClient.name} >{this.state.formData.client.masterClient.name}</option>
                              : this.renderSelectOptions()
                            }
                          </MyPATSelect>
                       </>}
                      </Grid>
                    </Grid>
                </Card>

                <Grid>
                  <Typography className={classes.CardTitle}>
                    Client/Org. Admin
                  </Typography>
                </Grid>
                <Card className={classes.CustomCard}>
                  <Grid container spacing={8} alignItems="center">
                    <Grid item xs={6}>
                      <Typography
                        variant="body1"
                        gutterBottom
                        className={classes.fontSizeMD}
                      >
                        Name
                      </Typography>
                      <MyPATTextField
                        className={classes.inputWidth}
                        fullWidthControl
                        inputId="fullName"
                        name="fullName"
                        placeholder="Enter the name of the admin"
                        // disabled={actionType === GOAL_ACTION_TYPE_CONST.READ_ONLY}
                        value={this.state.formData.user.fullName || ''}
                        onChange={this.handleChange.bind(this)}
                        error={
                          // !this.state.isEdit.editedName &&
                          this.state.formErrors.fullName !== 'valid'
                            ? true
                            : false
                        }
                        errorText={this.state.formErrors.fullName}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <Typography
                        variant="body1"
                        gutterBottom
                        className={classes.fontSizeMD}
                      >
                        Email ID
                      </Typography>
                      <MyPATTextField
                        className={[classes.inputWidth, (this.state.clientData.user.email && this.state.clientData.user.email) ? classes.customDisabled : ''].join(' ')}
                        fullWidthControl
                        inputId="email"
                        name="email"
                        placeholder="Enter the email ID of the admin"
                        // disabled={actionType === GOAL_ACTION_TYPE_CONST.READ_ONLY}
                        value={this.state.formData.user.email || ''}
                        onChange={this.handleChange.bind(this)}
                        error={
                          // !this.state.isEdit.editedEmail &&
                          this.state.formErrors.email !== 'valid' ||
                          this.props.editFormErrors.email.includes('Email') ||
                          this.props.editFormErrors.email.includes('primary client')
                            ? true
                            : false
                        }
                        errorText={
                          this.state.formErrors.email === 'valid'
                            ? this.props.editFormErrors.email
                            : this.state.formErrors.email
                        }
                      />
                    </Grid>
                  </Grid>
                  <Grid container spacing={8} alignItems="center">
                    <Grid item xs={6}>
                      <Typography
                        variant="body1"
                        gutterBottom
                        className={classes.fontSizeMD}
                      >
                        Contact
                      </Typography>
                      <div className={classes.flagContainer}>
                        <FormControl>
                          <Select
                            value={this.state.formData.user.mobile.countryCode}
                            onChange={(e) => this.handleCountryCodeChange(e)}
                            displayEmpty
                            name="countryCode"
                            disableUnderline={true}
                            classes={{ root: classes.customSelect }}
                            className={this.state.clientData.user.mobile.countryCode && this.state.clientData.user.mobile.countryCode.length ? classes.customDisabled : ''}
                          >
                            {countryListItems}
                          </Select>
                        </FormControl>
                        <MyPATTextField
                          fullWidthControl
                          className={[
                            classes.customInput,
                            classes.inputWidth,
                            this.state.clientData.user.mobile.number && this.state.clientData.user.mobile.number.length ? classes.customDisabled : '',
                          ].join(' ')}
                          inputId="number"
                          name="number"
                          placeholder="Enter Contact No."
                          // disabled={actionType === GOAL_ACTION_TYPE_CONST.READ_ONLY}
                          value={this.state.formData.user.mobile.number || ''}
                          onChange={this.handleChange.bind(this)}
                          error={
                            this.state.formErrors.number !== 'valid' ||
                            this.props.editFormErrors.number.includes('Mobile')
                              ? true
                              : false
                          }
                          errorText={
                            this.state.formErrors.number === 'valid'
                              ? this.props.editFormErrors.number
                              : this.state.formErrors.number
                          }
                        />
                      </div>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography
                        variant="body1"
                        gutterBottom
                        className={classes.fontSizeMD}
                      >
                        EMP Code
                      </Typography>
                      <MyPATTextField
                        className={[classes.inputWidth, (this.state.clientData.user.empCode && this.state.clientData.user.empCode) ? classes.customDisabled : ''].join(' ')}
                        fullWidthControl
                        inputId="empCode"
                        name="empCode"
                        placeholder="Enter the EMP Code"
                        // disabled={actionType === GOAL_ACTION_TYPE_CONST.READ_ONLY}
                        value={this.state.formData.user.empCode || ''}
                        onChange={this.handleChange.bind(this)}
                        error={
                          this.state.formErrors.empCode !== 'valid' ||
                          this.props.editFormErrors.empCode.includes('empCode')
                            ? true
                            : false
                        }
                        errorText={
                          this.state.formErrors.empCode === 'valid'
                            ? this.props.editFormErrors.empCode
                            : this.state.formErrors.empCode
                        }
                      />
                    </Grid>
                  </Grid>
                </Card>

                <Grid>
                  <Typography className={classes.CardTitle}>
                    Module Access
                    <span className={classes.iconStyle}>
                      <CustomInfoIcon
                        isInfoIcon={true}
                        isCenterArrow={true}
                        isRightArrow={false}
                        knowMoreAbout={false}
                        dialogTitle="Modules Access"
                        imageURL="/assets/svg/lock-icon.svg"
                        dialogPara="Through this section, access for each module can be provided to the organization.By marking yes permission , you are allowing the organization to acess the module otherwise the module will not be visible in the left pane"
                        toolTipDirection="top"
                        details="Click to know more"
                      />
                    </span>
                  </Typography>
                </Grid>
                <Card className={classes.CustomCard}>
                  <Grid container spacing={8} alignItems="center">
                    <Grid item xs={3}>
                      <Typography>Goal Management :</Typography>
                    </Grid>
                    <Grid item xs={9}>
                      <Grid container spacing={8} alignItems="center">
                        <FormGroup row>
                          <FormControlLabel
                            // classes={{ root: classes.labelText }}
                            // className={classes.marginTopMD}
                            className={classes.customRadio}
                            control={
                              <Radio
                                color="primary"
                                checked={Boolean(
                                  this.state.formData.client.moduleAccess[0]
                                    .isAllowed
                                )}
                                onChange={(event) =>
                                  this.handleModuleAccess(event, 0)
                                }
                                value="Yes"
                                name="goal"
                              />
                            }
                            label="Yes"
                          />

                          <FormControlLabel
                            // classes={{ root: classes.labelText }}
                            // className={classes.marginTopMD}
                            className={classes.customRadio}
                            control={
                              <Radio
                                color="primary"
                                checked={
                                  !Boolean(
                                    this.state.formData.client.moduleAccess[0]
                                      .isAllowed
                                  )
                                }
                                onChange={(event) =>
                                  this.handleModuleAccess(event, 0)
                                }
                                value="No"
                                name="goal"
                              />
                            }
                            label="No"
                          />
                        </FormGroup>
                        <FormGroup row>
                          <Grid
                            justify="center"
                            className={classes.flexContainer}
                          >
                            <Typography className={classes.customRadio}>
                              User Management :
                            </Typography>
                            <FormControlLabel
                              // classes={{ root: classes.labelText }}
                              // className={classes.marginTopMD}
                              className={classes.customRadio}
                              control={
                                <Radio
                                  color="primary"
                                  checked={Boolean(
                                    this.state.formData.client.moduleAccess[3]
                                      .isAllowed
                                  )}
                                  onChange={(event) =>
                                    this.handleModuleAccess(event, 3)
                                  }
                                  value="Yes"
                                  name="user"
                                />
                              }
                              label="Yes"
                            />

                            <FormControlLabel
                              // classes={{ root: classes.labelText }}
                              // className={classes.marginTopMD}
                              className={classes.customRadio}
                              control={
                                <Radio
                                  color="primary"
                                  checked={
                                    !Boolean(
                                      this.state.formData.client.moduleAccess[3]
                                        .isAllowed
                                    )
                                  }
                                  onChange={(event) =>
                                    this.handleModuleAccess(event, 3)
                                  }
                                  value="No"
                                  name="user"
                                />
                              }
                              label="No"
                            />
                          </Grid>
                        </FormGroup>
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid container spacing={8} alignItems="center">
                    <Grid item xs={3}>
                      <Typography>Course Management :</Typography>
                    </Grid>
                    <Grid item xs={9}>
                      <Grid container spacing={8} alignItems="center">
                        <FormGroup row>
                          <FormControlLabel
                            // classes={{ root: classes.labelText }}
                            // className={classes.marginTopMD}
                            className={classes.customRadio}
                            control={
                              <Radio
                                color="primary"
                                checked={Boolean(
                                  this.state.formData.client.moduleAccess[1]
                                    .isAllowed
                                )}
                                onChange={(event) =>
                                  this.handleModuleAccess(event, 1)
                                }
                                value="Yes"
                                name="course"
                              />
                            }
                            label="Yes"
                          />

                          <FormControlLabel
                            // classes={{ root: classes.labelText }}
                            // className={classes.marginTopMD}
                            className={classes.customRadio}
                            control={
                              <Radio
                                color="primary"
                                checked={
                                  !Boolean(
                                    this.state.formData.client.moduleAccess[1]
                                      .isAllowed
                                  )
                                }
                                onChange={(event) =>
                                  this.handleModuleAccess(event, 1)
                                }
                                value="No"
                                name="course"
                              />
                            }
                            label="No"
                          />
                        </FormGroup>
                        <FormGroup row>
                          <Grid
                            justify="center"
                            className={classes.flexContainer}
                          >
                            <Typography className={[classes.customRadio, classes.labelCustomWidth].join(' ')}>
                              EDP Reports :
                            </Typography>
                            <FormControlLabel
                              // classes={{ root: classes.labelText }}
                              // className={classes.marginTopMD}
                              className={classes.customRadio}
                              control={
                                <Radio
                                  color="primary"
                                  checked={Boolean(
                                    this.state.formData.client.moduleAccess[4]
                                      .isAllowed
                                  )}
                                  onChange={(event) =>
                                    this.handleModuleAccess(event, 4)
                                  }
                                  value="Yes"
                                  name="EDPReports"
                                />
                              }
                              label="Yes"
                            />

                            <FormControlLabel
                              // classes={{ root: classes.labelText }}
                              // className={classes.marginTopMD}
                              className={classes.customRadio}
                              control={
                                <Radio
                                  color="primary"
                                  checked={
                                    !Boolean(
                                      this.state.formData.client.moduleAccess[4]
                                        .isAllowed
                                    )
                                  }
                                  onChange={(event) =>
                                    this.handleModuleAccess(event, 4)
                                  }
                                  value="No"
                                  name="EDPReports"
                                />
                              }
                              label="No"
                            />
                          </Grid>
                        </FormGroup>
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid container spacing={8} alignItems="center">
                    <Grid item xs={3}>
                      <Typography>Content Request :</Typography>
                    </Grid>
                    <Grid item xs={9}>
                    <Grid container spacing={8} alignItems="center">
                      <FormGroup row>
                        <FormControlLabel
                          // classes={{ root: classes.labelText }}
                          // className={classes.marginTopMD}
                          className={classes.customRadio}
                          control={
                            <Radio
                              color="primary"
                              checked={Boolean(
                                this.state.formData.client.moduleAccess[2]
                                  .isAllowed
                              )}
                              onChange={(event) =>
                                this.handleModuleAccess(event, 2)
                              }
                              value="Yes"
                              name="contentRequest"
                            />
                          }
                          label="Yes"
                        />

                        <FormControlLabel
                          // classes={{ root: classes.labelText }}
                          // className={classes.marginTopMD}
                          className={classes.customRadio}
                          control={
                            <Radio
                              color="primary"
                              checked={
                                !Boolean(
                                  this.state.formData.client.moduleAccess[2]
                                    .isAllowed
                                )
                              }
                              onChange={(event) =>
                                this.handleModuleAccess(event, 2)
                              }
                              value="No"
                              name="contentRequest"
                            />
                          }
                          label="No"
                        />
                      </FormGroup>
                    </Grid>
                    </Grid>
                  </Grid>
                </Card>
              {/* </form> */}
            </CardContent>
            <CardActions classes={{ root: classes.footerFixed }}>
            <div className={classes.btnGroup}>
              <Button
                variant="contained"
                color="primary"
                className={classes.btnCreateGoal}
                // type="submit"
                disabled={!this.state.isFormValid}
                onClick={this.handleSubmit}
              >
                Update Client
              </Button>
              </div>
            </CardActions>
          </Card>
        </div>
      </Modal>
      </>
    );
  }
}

const mapStateToProps = (state: any) => ({
  client: state.clientManagement.clientMgmt.editClient,
  editFormErrors: state.clientManagement.clientMgmt.editFormErrors,
  clientEditedSuccessfully:
    state.clientManagement.clientMgmt.clientEditedSuccessfully,
  masterClientsData:
  state.clientManagement.clientMgmt.masterClientsData 
  &&
  state.clientManagement.clientMgmt.masterClientsData.clients
});

const mapDispatchToProps = {
  getClient,
  editClient,
  editClientToastClose,
  editClientCorrection,
  getMasterClients
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(withStyles(userStyles)(withRouter(EditClientDialog)));
